import { useEffect } from 'react'

export function useKioskTouch() {
  useEffect(() => {
    const stopGesture = (event: Event) => event.preventDefault()
    const onWheel = (event: WheelEvent) => {
      if (event.ctrlKey) event.preventDefault()
    }
    const gestures = ['gesturestart', 'gesturechange', 'gestureend']
    for (const gesture of gestures) document.addEventListener(gesture, stopGesture, { passive: false })
    document.addEventListener('wheel', onWheel, { passive: false })
    // CSS touch-action: manipulation handles double taps. Preventing touchend
    // would swallow synthesized clicks, including the first tap on Pay.
    return () => {
      for (const gesture of gestures) document.removeEventListener(gesture, stopGesture)
      document.removeEventListener('wheel', onWheel)
    }
  }, [])
}
